import { create } from 'zustand';

type AppMode = 'recruit' | 'agentforge';

interface AppModeState {
  mode: AppMode;
  setMode: (_mode: AppMode) => void;
}

const getPersistedMode = (): AppMode => {
  try {
    const stored = localStorage.getItem('kula-app-mode');
    return stored === 'agentforge' ? 'agentforge' : 'recruit';
  } catch {
    return 'recruit';
  }
};

export const useAppMode = create<AppModeState>((set) => ({
  mode: getPersistedMode(),
  setMode: (mode) => {
    localStorage.setItem('kula-app-mode', mode);
    set({ mode });
  },
}));
